import useMovieTrailer from '../../../../../hooks/useMovieTrailer';
import { RootState } from '../../../../../store/appStore';
import { VideoBackgroundType } from '../../../../../types';
import { YOUTUBE_VIDEO_URL } from '../../../../../utils/constants';
import { useAppSelector } from '../../../../../utils/hooks';

const VideoBackground = ({ movieId, title }: VideoBackgroundType) => {
  const trailerVideo = useAppSelector(
    (store: RootState) => store.movies?.trailerVideo
  );
  useMovieTrailer(movieId);

  return (
    <iframe
      className='w-full aspect-video'
      src={
        YOUTUBE_VIDEO_URL +
        trailerVideo?.key +
        '?autoplay=1&mute=1&enablejsapi=1&showinfo=0&controls=0&rel=0&playlist=' +
        trailerVideo?.key +
        '&loop=1'
      }
      title={title}
      data-testid={title}
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'></iframe>
  );
};

export default VideoBackground;
